import {baseUrl, getQueryParam, setQueryParam} from 'src/utils/url';
class StyleComplements {
  constructor() {
    this.complementsSectionLoaded = false;
    this.complementsSelector = '.pc-Style-complements';
    this.complementsContentSelector = '.pc-Style-complements-content';
    this.labLinkSelector = '.pc-Style-complements-textSubtitle-link';
    if ($(this.complementsSelector).length > 0) {
      this.initBehavior();
      this.fetchComplements = this.fetchComplements.bind(this);
      this.updateLabLink = this.updateLabLink.bind(this);
      const options = {rootMargin: '0px 0px 150px 0px'};
      const complementsObserver = new IntersectionObserver(
        (entries, observer) => {
          return this.handleIntersect(entries, observer);
        },
        options
      );
      complementsObserver.observe(
        document.querySelector(this.complementsSelector)
      );
    }
  }

  initBehavior() {
    $(document).on(
      'click',
      '.pc-Style-complements-content .pc-ProductCard-link',
      this.cardLinkClicked
    );

    $(document).on('swatchselect.style.colorinteraction', (e, data) => {
      if (
        !ProductCatalog.QuickView.isQuickView() &&
        this.complementsSectionLoaded
      ) {
        this.fetchComplements(data);
      }
      return this.updateLabLink(data);
    });
  }

  handleIntersect(entries, observer) {
    return entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        this.fetchComplements();
        this.complementsSectionLoaded = true;
        observer.unobserve(document.querySelector(this.complementsSelector));
      }
    });
  }

  fetchComplements(data) {
    let url = `${baseUrl()}/complements.html`;
    const productId = data ? data.id : $('.pc-Swatch.is-selected').data('id');
    url = setQueryParam('PK', productId, url);
    if (ProductCatalog.IFrame.iframer()) {
      url = setQueryParam('iframer', ProductCatalog.IFrame.iframer(), url);
    }
    return $.ajax(url, {
      type: 'GET',
      error: (jqXHR, textStatus, errorThrown) => {
        $(this.complementsSelector).css({padding: 0});
        $(this.complementsSelector).html('');
      },
      success: (responseHtml) => {
        const $node = $(responseHtml).filter(this.complementsContentSelector);
        if (!$.trim($node.html()).length) {
          $(this.complementsSelector).css({padding: 0});
          return;
        }
        $(this.complementsSelector).html(responseHtml);
        $('.pc-Style-complements-content').children('.pc-ProductCard').slice(4).hide();
        return $(this.complementsContentSelector)
          .find('.pc-lazyImage-isLoading')
          .each((idx, e) => {
            return ProductCatalog.ImageLazyLoader !== null
              ? ProductCatalog.ImageLazyLoader.lazyImageObserver.observe(e)
              : undefined;
          });
      }
    });
  }

  updateLabLink(data) {
    const link = $(this.labLinkSelector);
    if (!link.length) {
      return;
    }
    const url = setQueryParam('PK', data.colorid, link.attr('href'));
    return link.attr('href', url);
  }

  cardLinkClicked(e) {
    const styleName = $(this).find('.pc-ProductCard-detailTitle').text();
    return CustomInk.Metrics.fireEvent({
      category: 'complementary styles',
      action: 'PDP',
      label: styleName.trim()
    });
  }
}

jQuery(() => (ProductCatalog.StyleComplements = new StyleComplements()));
